import React, { useEffect } from "react";
import * as styles from "./Root.module.css";
import PlateWithLogo from "../assets/plate-with-logo.png";
import { Button } from "primereact/button";

const Root = () => {
  return (
    <div className={styles.wrapper}>
      <img src={PlateWithLogo} alt="" />
      <h1>Lost Your Appetite or Just Lost?</h1>
      <p>You’ve reached the Main Kitchen — but the menu’s not here!</p>
      <p>
        Looks like you’ve landed at the home base of Dine Without the Line —
        where all the behind-the-scenes magic happens.
      </p>
      <p>
        But here’s the scoop: each organization that uses DWTL gets its own
        custom food hub, complete with tailored menus, pickup spots, and order
        options designed just for them.
      </p>
      <p>
        Whether you followed a funky link or just got a little too curious, no
        worries — we’ve got your back (and your belly)!
      </p>

      <div className={styles.CTAWrapper}>
        <p>👉 Need a hand finding right page for your organization?</p>
        <a href="https://1fiit.com/contact/" target="_blank">
          Reach Out To Us!{" "}
        </a>
      </div>
    </div>
  );
};

export default Root;
